export default __webpack_public_path__ + "static/media/bell.71ad8cf2.mp3";